/**
 * @description 系統訊息 ID (enum)
 */
export enum SystemMessageIdEnum {
  /** 取消投保確認說明 */
  CConfirm = 'CConfirm',
  /** 未繳費取消投保退費說明 */
  NoPay = 'NoPay',
  /** 信用卡取消投保退費說明 */
  Nccc = 'Nccc',
  /** 活期帳戶取消投保退費說明 */
  Ebill = 'Ebill',
  /** 保費計算選單無可選選項 */
  W001 = 'W001',
  /** 一年未變更密碼 */
  W009 = 'W009'
}
